<div class="topbar" [ngClass]="{ 'theme-dark': isDarkMode() }">
  <div class="search-section">
    <mat-form-field class="search-bar" appearance="outline">
      <mat-label>Client Name</mat-label>
      <input matInput [(ngModel)]="searchTerm" (input)="inputSearch()" />
      <mat-icon matSuffix *ngIf="searchTerm" style="cursor: pointer; margin-top: 3px;" (click)="clearSearch()" class="close-icon">close</mat-icon>
    </mat-form-field>
  </div>
  <button mat-raised-button color="primary" class="add-button" (click)="openAddClientDialog()">
    Add Client
  </button>
</div>

<div *ngIf="dataSource?.data as data">
  <ng-container *ngIf="data.length > 0; else noData">
    <div class="table-container" (scroll)="onManualScroll()">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" [ngClass]="{ 'dark-table': isDarkMode() }">

        <ng-container matColumnDef="Sl.No">
          <th mat-header-cell *matHeaderCellDef style="width:70px;">Sl.No</th>
          <td mat-cell *matCellDef="let element; let i = index" style="text-align: center">{{ i + 1 }}</td>
        </ng-container>

        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef style="width:250px; word-wrap: break-word;">Client Name</th>
          <td mat-cell *matCellDef="let element" style="text-align: left;">{{ element.company_name }}</td>
        </ng-container>
        <ng-container matColumnDef="Action">
          <th mat-header-cell *matHeaderCellDef style="width:70px;">Action</th>
          <td mat-cell *matCellDef="let element">
            <button class="edit-icon-button" mat-icon-button matTooltip="view more" matTooltipPosition="above"
              (click)="openDialog(element)">
              <mat-icon fontSet="material-symbols-outlined">info</mat-icon>
            </button>

            <button class="edit-icon-button" mat-icon-button matTooltip="Edit" (click)="openEditClientDialog(element)">
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </ng-container>
</div>

<ng-template #noData>
  <div class="no-data-text">
    No data found.
  </div>
</ng-template>